import React, { useState } from 'react'
import Field from './Field'
import useStyles from './styles'
import styles from './Login.module.css'
import jwtDecode from 'jwt-decode'
import {useDispatch} from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { signup, signin } from '../../actions/auth'
import { Avatar, Button, Paper, Grid, Typography, Container } from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import { createProfile } from '../../actions/profile'
import { useSnackbar } from 'react-simple-snackbar'
import CircularProgress from '@material-ui/core/CircularProgress';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';




const initialState ={ firstName: '', lastName: '', email: '', password: '', confirmPassword: '', roleId:0}

const Login = () => {

    const classes = useStyles();
    const [formData, setFormData] = useState(initialState)
    const [isSignup, setIsSignup] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const [showPassword, setShowPassword] = useState(false);
     // eslint-disable-next-line 
    const [openSnackbar, closeSnackbar] = useSnackbar()
    const user = JSON.parse(localStorage.getItem('profile'))
    const [loading, setLoading] = useState(false)
    
    const handleShowPassword = () => setShowPassword(!showPassword);
    const handleChange =(e)=> {
        setFormData( {...formData, [e.target.name] : e.target.value} )
    }

    const handleSubmit =(e) => {
        e.preventDefault()
        if(isSignup) {
            dispatch(signup(formData, openSnackbar, setLoading))
        } else {
            dispatch(signin(formData, openSnackbar, setLoading))
        }
        setLoading(true)
    }


    const switchMode =() => {
        setIsSignup((prevState) => !prevState)
    }



    if(user) {
      history.push('/dashboard')
    }

    return (
        <Container component="main" maxWidth="xs">
      <Paper className={classes.paper} elevation={2}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">{ isSignup ? 'Sign up' : 'Sign in' }</Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            { isSignup && (
            <>
              <Field name="firstName" label="First Name" handleChange={handleChange} autoFocus half />
              <Field name="lastName" label="Last Name" handleChange={handleChange} half />
            </>
            )}
            <Field name="email" label="Email Address" value="tajuddin76@hotmail.com" handleChange={handleChange} type="email" />
            <Field name="password" label="Password" value="test1234" handleChange={handleChange} type={showPassword ? 'text' : 'password'} handleShowPassword={handleShowPassword} />
            { isSignup && <Field name="confirmPassword" label="Repeat Password" handleChange={handleChange} type="password" /> }
            { isSignup &&          
              <Grid item xs={12} sm={6}>   

              <Select  onChange={handleChange}  name="roleId" style={{width:300}} >
                <MenuItem value="0">
                  <em>Select role</em>
                </MenuItem>
                <MenuItem value="1">Admin</MenuItem>
                <MenuItem value="2">Editor</MenuItem>
                <MenuItem value="3">Operator</MenuItem>
              </Select>
            
             </Grid>
             }
          </Grid>
          <div className={styles.buttons}>
               <div>
                    {/* <button className={styles.submitBtn}> { isSignup ? 'Sign Up' : 'Sign In' }</button> */}
                    {/* <ProgressButton>{ isSignup ? 'Sign Up' : 'Sign In' }</ProgressButton> */}
                    {loading ? <CircularProgress /> 
                    : 
                    <button className={styles.loginBtn} >{ isSignup ? 'Sign Up' : 'Sign In' }</button>
                    }
                    
                </div>
               
          </div>
          
   
        </form>
      </Paper>
    </Container>
    )
}

export default Login
